var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.89L14.07 9.075L14.415 9.825L15.165 9.9375L19.785 10.605L16.5 13.83L15.9375 14.3775L16.0725 15.1275L16.86 19.725L12.7275 17.5575L12 17.25L11.3025 17.6175L7.16996 19.755L7.91996 15.1575L8.05496 14.4075L7.49996 13.83L4.18496 10.5675L8.80496 9.9L9.55496 9.7875L9.89996 9.0375L12 4.89ZM12 1.5L8.58746 8.415L0.959961 9.5175L6.47996 14.9025L5.17496 22.5L12 18.915L18.825 22.5L17.52 14.9025L23.04 9.525L15.4125 8.415L12 1.5Z",
    fill: "#1E1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarOutlined);
export default __webpack_public_path__ + "static/media/Ic_Star--outlined.cbf9a129f483f2c55a09dda43d84b927.svg";
export { ForwardRef as ReactComponent };